import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { SwalService } from '@shared/utils/swal.service';
import { MotivoService, IMotivo, IMotivoRequest, IOpcion } from '@p-parametria/mantenimiento/abc-motivos/services/motivo.service';

@Component({
  selector: 'app-abc-motivo-form',
  templateUrl: './abc-motivo-form.component.html',
  styleUrls: ['./abc-motivo-form.component.css']
})
export class AbcMotivoFormComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() model: IMotivo | null;
  
  loading: boolean = false;
  modelRecived: IMotivo | null = null;
  listTipos: IOpcion[] = [];
  listTipo_Motivo: IOpcion[] = [];

  form = this._fb.group({
    motivo: ['', [Validators.required]],
    tipo: ['', [Validators.required]],
    descripcion: ['', [Validators.required]],
    tipo_motivo: ['', [Validators.required]]
  });

  constructor(
    private _fb: UntypedFormBuilder,
    private motivoService: MotivoService,
    private _swalService: SwalService
  ) {}

  ngOnInit(): void {
    this.LoadTipos();
    this.LoadTipo_Motivo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model'] && changes['model'].currentValue) {
      this.setForm();
    } else if (changes['visible'] && changes['visible'].currentValue) {
      if (!this.model) {
        this.form.reset();
        this.form.controls["motivo"].enable();
      }
    }
  }

  LoadTipo_Motivo() {
    this.loading = true;
    this.motivoService.GetCmsprOpciones("motivos", "Tipo_Motivo").subscribe({
      next: (response) => {
        if (response.success) {
          this.listTipo_Motivo = response.data;
        } else {
          this._swalService.error('Error al cargar los tipos de motivo');
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar tipos de motivo:', error);
        this._swalService.error('Error al cargar los tipos de motivo');
        this.loading = false;
      }
    });
  }

  LoadTipos() {
    this.loading = true;
    this.motivoService.GetCmsprOpciones("motivos", "tipo").subscribe({
      next: (response) => {
        if (response.success) {
          this.listTipos = response.data;
        } else {
          this._swalService.error('Error al cargar los tipos');
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar tipos:', error);
        this._swalService.error('Error al cargar los tipos');
        this.loading = false;
      }
    });
  }

  formValue(value: string) {
    return this.form.get(value);
  }

  setForm(): void {
    if (this.model) {
      this.modelRecived = { ...this.model };
      const tipoMotivoOption = this.listTipo_Motivo.find(opt => opt.sValor === this.model.tipo_motivo);
      const tipoOption = this.listTipos.find(opt => opt.sOpcion === this.model.tipo);
      this.form.patchValue({
        motivo: this.model.motivo,
        tipo: tipoOption ? tipoOption.sValor : this.model.tipo,
        descripcion: this.model.descripcion,
        tipo_motivo: tipoMotivoOption ? tipoMotivoOption.sValor : this.model.tipo_motivo
      });
      this.form.controls["motivo"].disable();
    } else {
      this.form.reset();
      this.form.controls["motivo"].enable();
    }
  }

  create(model: any) {
    if (this.form.valid) {
      this.loading = true;
      const motivo: IMotivo = {
        motivo: model.motivo,
        tipo: model.tipo,
        descripcion: model.descripcion,
        tipo_motivo: model.tipo_motivo
      };

      this.motivoService.AddMotivo(motivo).subscribe({
        next: (response) => {
          if (response.success && response.data) {
            this._swalService.success('Motivo agregado correctamente');
            this.close(true);
          } else {
            this._swalService.error('No se pudo agregar el motivo. El código ya existe, por favor use uno diferente');
          }
        },
        error: (error) => {
          console.error('Error al crear motivo:', error);
          this._swalService.error('Error al crear el motivo');
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
  }

  update(model: any) {
    if (this.form.valid) {
      this.loading = true;
      const motivo: IMotivo = {
        motivo: this.modelRecived?.motivo || '',
        tipo: model.tipo,
        descripcion: model.descripcion,
        tipo_motivo: model.tipo_motivo
      };

      this.motivoService.UpdateMotivo(motivo).subscribe({
        next: (response) => {
          if (response.success && response.data) {
            this._swalService.success('Motivo actualizado correctamente');
            this.close(true);
          } else {
            this._swalService.error('No se pudo actualizar el motivo');
          }
        },
        error: (error) => {
          console.error('Error al actualizar motivo:', error);
          this._swalService.error('Error al actualizar el motivo');
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
  }

  close(refresh: boolean = false) {
    this.visible = false;
    this.visibleChange.emit(refresh);
  }
}
